export default __webpack_public_path__ + "static/media/Tasset of Courageous Souls.121c216d.jpg";